
import * as React from "react";

// Use higher breakpoint to better handle tablets and small screens
const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    // Set initial value with SSR check
    if (typeof window !== 'undefined') {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }
    return false;
  });

  React.useEffect(() => {
    // Use media query for more reliability
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    
    const handleResize = () => {
      setIsMobile(mql.matches);
    };
    
    // Modern event listener
    mql.addEventListener("change", handleResize);
    
    // Set initial value
    handleResize();
    
    // Cleanup
    return () => mql.removeEventListener("change", handleResize);
  }, []);

  return isMobile;
}
